import { render, staticRenderFns } from "./SupplierGroupFormModal.vue?vue&type=template&id=5d410338&scoped=true"
import script from "./SupplierGroupFormModal.vue?vue&type=script&lang=js"
export * from "./SupplierGroupFormModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierGroupFormModal.vue?vue&type=style&index=0&id=5d410338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d410338",
  null
  
)

export default component.exports